import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import HelpDropdown from './HelpDropdown';
import UserDropdown from './UserDropdown';

export default class LargeHeaderContent extends Component {
  static propTypes = {
    userLoggedIn: PropTypes.bool,
    onClickLogin: PropTypes.func.isRequired,
    onClickLogout: PropTypes.func.isRequired,
    userData: ImmutablePropTypes.map.isRequired,
    username: PropTypes.string,
    userAvatarUrl: PropTypes.string,
    children: PropTypes.node,
  };

  render() {
    return (
      <div className="header-content-menus">
        {this.props.children}
        <HelpDropdown />
        {this.props.userLoggedIn ? (
          <UserDropdown
            onClickLogout={this.props.onClickLogout}
            userData={this.props.userData}
            userAvatarUrl={this.props.userAvatarUrl}
            username={this.props.username}
          />
        ) : (
          <a
            className="log-in-link"
            href={this.props.userData.getIn(['_links', 'login', 'href'])}
            onClick={this.props.onClickLogin}
          >
            Log in
          </a>
        )}
      </div>
    );
  }
}
